import React from 'react';
import ReactTooltip from 'react-tooltip';

const SelectComponent = ({
  title, onChange, value, body, tooltip, disabled = false,
}) => (
  <div className="form-group">
    {tooltip ? (
      <React.Fragment>
        <ReactTooltip
          id={title}
          place="right"
          type="dark"
          effect="solid"
          getContent={dataTip => (<p className="tooltip-select-small">{dataTip}</p>)}
        />
        <p className="margin-bottom-2">
          {title}
          &nbsp;
          <i className="fas fa-question-circle" value="open" data-tip={tooltip} data-for={title} />
        </p>
      </React.Fragment>
    ) : <p className="margin-bottom-2">{title}</p>}
    <select
      onChange={onChange}
      className="custom-select"
      value={value}
      required
      disabled={disabled}
    >
      <option value="" />
      {body}
    </select>
  </div>
);

export default SelectComponent;
